import React, { useState, useEffect } from 'react';
import DashboardLayout from '../Dashboard/layout';
import { useNavigate } from 'react-router-dom';
import axios from 'axios'; 
import Swal from 'sweetalert2';
import "./DomainPage.css";
import { ADDBTN, Headings, SerchInput, UserSelect } from '../RegisteredUsersList/ViewRegList';
import { FaAngleDoubleLeft , FaAngleDoubleRight } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { FiEdit } from "react-icons/fi";

const ViewDomainPageList = () => {
  const [domains, setDomains] = useState([]);
  const [filteredDomains, setFilteredDomains] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [domainsPerPage] = useState(5); 
  const navigate = useNavigate();
  
  useEffect(() => {
    const fetchDomains = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}api/admin/domains`);
        if (response.data && response.data.domains && response.data.domains.length > 0) {
          setDomains(response.data.domains);
          setFilteredDomains(response.data.domains);
        } else {
          //Swal.fire('No Data Available', 'There are no domains available at the moment.', 'info');
        }
      } catch (error) {
        console.error('Failed to fetch domains:', error);
        Swal.fire('Error', 'Failed to load domains. Please try again later.', 'error');
      } finally {
        setLoading(false);
      }
    };

    fetchDomains();
  }, []);

  useEffect(() => {
    let filtered = domains;

    if (selectedStatus) {
      filtered = filtered.filter((domain) => domain.status === parseInt(selectedStatus));
    }

    if (searchQuery) {
      filtered = filtered.filter(
        (domain) =>
          domain.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    setFilteredDomains(filtered);
    setCurrentPage(1);
  }, [selectedStatus, searchQuery, domains]);

  // Delete a domain
  const handleDeleteDomain = (domainId) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this domain!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${process.env.REACT_APP_BASE_URL}api/admin/domains/${domainId}`)
          .then(() => {
            setDomains(domains.filter((domain) => domain._id !== domainId));
            setFilteredDomains(filteredDomains.filter((domain) => domain._id !== domainId));
            Swal.fire('Deleted!', 'The domain has been deleted.', 'success');
          })
          .catch((error) => {
            console.error('Error deleting domain:', error);
            Swal.fire('Error', 'There was an issue deleting this domain.', 'error');
          });
      }
    });
  };

  // Edit domain (redirect to edit page)
  const handleEditDomain = (domainId) => {
    navigate(`/edit-domain/${domainId}`); 
  };

  // Pagination logic
  const indexOfLastDomain =  (currentPage - 1) * domainsPerPage;
  //const indexOfFirstDomain = indexOfLastDomain - domainsPerPage;
  const currentDomains = filteredDomains.slice(indexOfLastDomain, indexOfLastDomain+domainsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const totalPages = Math.ceil(filteredDomains.length / domainsPerPage);

  const handleAddDomainClick = () => {
    navigate('/add-domain'); 
  };

  const statusOptions = [
    { value: '', label: 'All' },
    { value: '1', label: 'Active' },
    { value: '0', label: 'Inactive' },
  ];

  return (
    <>
      <DashboardLayout>
        <section className='MainDivSec'>

          <Headings headspan="Domain" hedtext=" List " />

          <div className="TopSelctDiv">
            <div className="LeftSlct">
              <UserSelect slctvluename="Filter by Status:" selectedRole={selectedStatus} slctonchange={(e) => setSelectedStatus(e.target.value)} options={statusOptions} slcthtmlfor="statusFilter" />
            </div>
            <div className="RytSrch">
              <SerchInput searchvalue={searchQuery} searchonchange={(e) => setSearchQuery(e.target.value)} srchid="searchQuery" srchplcehldr="Search by name" />
              <ADDBTN adtext="Add Domain" adonclick={handleAddDomainClick}/>
            </div>
          </div>

          <div className="TableSec">

            {loading ? (
              <p className="Loadingpara">Loading...</p>
            ) : (
            <>

            <div className="UserTableDiv">
              <table className="User_Table">
                <thead>
                  <tr>
                    <th>SR NO</th>
                    <th>Name</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                 {currentDomains.length === 0 ? (
                    <tr>
                      <td colSpan="4" style={{ textAlign: "center", padding: "12px", color: "#999" }}>
                        Domain not found
                      </td>
                    </tr>
                  ) : (
                    currentDomains.map((domain, index) => (
                      <tr key={domain._id}>
                        <td>{indexOfLastDomain + index + 1}</td>
                        <td>{domain.name}</td>
                        <td>{domain.status === 1 ? 'Active' : 'Inactive'}</td>
                        <td className="EditDelteDiv">
                          <button onClick={() => handleEditDomain(domain._id)}><FiEdit /></button>
                          <button
                            className="delete-btn"
                            onClick={() => handleDeleteDomain(domain._id)}
                          >
                            <MdDelete />
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
              </tbody>
              </table>
            </div>
            {filteredDomains.length > 0 && (
            <div className="Tablepagination">
                <button onClick={() => paginate(currentPage - 1)}
                  disabled={currentPage === 1} >
                  <FaAngleDoubleLeft/>
                </button>
                {[...Array(totalPages)].map((_, index) => (
                  <button
                    key={index + 1}
                    onClick={() => paginate(index + 1)}
                    className={currentPage === index + 1 ? "active" : ""}
                  >
                    {index + 1}
                  </button>
                ))}
                <button onClick={() => paginate(currentPage + 1)}
                  disabled={currentPage === totalPages}>
                  <FaAngleDoubleRight />
                </button>
            </div>
            )}
            </>
            )}
          </div>

        </section>
        
      </DashboardLayout>
    </>
  );
};

export default ViewDomainPageList;
